import React, { useEffect } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';

import MainTitle from 'on_web/components/shared/Common/MainTitle';
import SplashScreen from 'on_web/components/shared/SplashScreen/SplashScreen';

import { useTranslation } from 'react-i18next';

export default function SkinCareIntro(props) {
  useEffect(() => {
    const timer = setTimeout(props.onWelcome, 3000);
    return () => clearTimeout(timer);
  });

  const { t } = useTranslation();
  return (
    <div>
      <Header />
      <SplashScreen>
        <MainTitle
          text={t('pceOnboarding.skinCareSection.skinCareIntro.mainTitleText')}
        ></MainTitle>
      </SplashScreen>
    </div>
  );
}
